import './styles/reset.css'; // Import reset CSS first
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App.tsx';
import './index.css';

// Add global error handling
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found');
} else {
  try {
    // Mount the app to the DOM
    createRoot(rootElement).render(
      <StrictMode>
        <App />
        <Analytics />
      </StrictMode>
    );
    console.log('App rendered successfully');
  } catch (error) {
    console.error('Error rendering app:', error);
    // Display a fallback UI for production errors
    rootElement.innerHTML = '<div style="padding: 20px; text-align: center;"><h1>Street Vape</h1><p>Coming Soon</p></div>';
  }
}